import { render, staticRenderFns } from "./BasicSchedule.vue?vue&type=template&id=3aaa37e4&"
import script from "./BasicSchedule.vue?vue&type=script&lang=js&"
export * from "./BasicSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BasicSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports